import React, { createContext } from 'react';

export const MyContext = createContext();
